const {Component} = require("react");
const {classList} = require("app/util/html");
const $ = require("app/util/element");

class ModalContainer extends Component {

	constructor(props) {
		super(props);

		this.state = {
			mounted: [],
			active: null
		};
	}

	componentDidMount() {
		// Close on press escape
		window.addEventListener("keyup", e => {
          if (e.key === 'Escape') {
            this.close();
          }
        });
	}

	get className() {
		return classList(
			"modal-container",
			this.state.active ? "open" : null
		);
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	updateBodyClass() {
		$(document.body).setClass("modal-open", this.state.active != null);
	}

	unmount(modal, callback) {
		return this.close(modal, () => {
			this.setState(state => {
				const index = state.mounted.indexOf(modal);

				if (index !== -1) {
					state.mounted.splice(index, 1);
				}

				return state;
			}, callback);
		});
	}

	mount(modal, callback) {
		this.setState(state => {
			state.mounted.push(modal);
			return state;
		}, callback);

		return this;
	}

	open(modal, callback) {
		this.setState({active: modal}, () => {
			this.updateBodyClass();
			modal.onOpen();

			if (typeof callback === "function") {
				callback();
			}
		});

		return this;
	}

	close(modal = null, callback = null) {
		if (typeof modal === "function") {
			callback = modal;
			modal = null;
		}

		if (modal && (this.state.active !== modal)) {
			if (typeof callback === "function") {
				callback();
			}

			return this;
		}

		const active = this.state.active;

		if (active && active.isCloseable()) {
			this.setState({active: null}, () => {
				this.updateBodyClass();
				active.onClose();

				if (typeof callback === "function") {
					callback();
				}
			});
		}

		return this;
	}

	isActive(modal) {
		return this.state.active === modal;
	}

	setActive(modal, state = true, callback = null) {
		return state ? this.open(modal, callback) : this.close(modal, callback);
	}

	/////////////////////////////////
	// Listeners
	/////////////////////////////////

	onOverlayClick = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.close();
	};

	/////////////////////////////////
	// Renderers
	/////////////////////////////////

	renderModals() {
		return this.state.mounted.map((modal, index) => {
			return modal.renderContent(index, modal === this.state.active);
		});
	}

	renderOverlay() {
		return (
          <div className="modal-overlay" onClick={this.onOverlayClick}></div>
		);
	}

	render() {
		return (
			<div className={this.className}>
				{this.renderOverlay()}
				{this.renderModals()}
			</div>
		);
	}

}

module.exports = ModalContainer;
